"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatGraphqlError = function (message) {
    return message.replace(/GraphQL error: Exception while fetching data \([^\)]+\) : /, '');
};
exports.default = formatGraphqlError;
